<template>
  <div class="content-warpper">
    <div class="warpper-title">
      <i class="iconfont icondingdan1"></i>
      证书发放记录详情
    </div>
    <div class="padding-sm">
      <div class="flex align-center justify-between margin-bottom-sm">
        <div class="flex align-center condition-warpper">
          <el-input
              v-model="stu_name"
              placeholder="请输入考生姓名"
              class="margin-right-sm"
          ></el-input>
          <el-input
              v-model="stu_idcard"
              placeholder="请输入身份证号"
              class="margin-right-sm"
          ></el-input>
          <el-input
              v-model="stu_phone"
              placeholder="请输入联系方式"
              class="margin-right-sm"
          ></el-input>

          <el-button type="primary" @click="onSearch">
            <p class="flex align-center font-size">
              <i class="el-icon-search margin-right-xs"></i>搜索
            </p>
          </el-button>
        </div>

      </div>
      <el-table
          :data="recordList"
          header-row-class-name="table-header"
          row-class-name="table-row"
          alig="center"
          fit
          style="width: 100%"
      >

        <el-table-column label="序号" type="index">
        </el-table-column>
        <el-table-column label="考生姓名">
          <template slot-scope="scope">
            <div class="table-item">
              {{ scope.row.stu_name }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="证件类型">
          <template>
            <div class="table-item">
              身份证
              <!--{{ scope.row.update_time }}-->
            </div>
          </template>
        </el-table-column>
        <el-table-column label="身份证号码">
          <template slot-scope="scope">
            <div class="table-item">
              {{ scope.row.stu_idcard }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="基础知识">
          <template slot-scope="scope">
            <div class="table-item">
              {{ scope.row.question_base_grade }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="实践案例">
          <template slot-scope="scope">
            <div class="table-item">
              {{ scope.row.question_practice_grade }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="实习成绩">
          <template slot-scope="scope">
            <div class="table-item">
              {{ scope.row.question_synthetical_grade }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="证书编号">
          <template slot-scope="scope">
            <div class="table-item">
              {{ scope.row.certnumber }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="联系方式">
          <template slot-scope="scope">
            <div class="table-item">
              {{ scope.row.stu_phone }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <div class="table-operate">

              <el-button type="primary" @click="onPreview(scope.row.urls)">查看证书</el-button>
            </div>
          </template>
        </el-table-column>

      </el-table>
      <el-pagination
          v-if="recordList.length > 0"
          class="page-all"
          background
          :current-page.sync="page"
          :page-size="limit"
          layout="prev, pager, next, jumper"
          :total="total"
      >
      </el-pagination>
    </div>
    <el-image-viewer
        v-if="showViewer"
        :on-close="closeViewer"
        :url-list="srcList"/>
  </div>
</template>

<script>
import {certRecord} from "@/api/projectOffice";
import ElButton from "../../../../node_modules/element-ui/packages/button/src/button.vue";
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import {IMGURL} from "@/config";

export default {
  components: {ElButton, ElImageViewer},
  name: "record",
  data() {
    return {
      imgStr:IMGURL,
      recordList: [],
      page: 1,
      total: 0,
      limit: 10,
      stu_name: '',
      stu_idcard: '',
      stu_phone: '',
      showViewer: false,
      srcList: []
    };
  },
  created() {
    this.$emit(
        "setIndex",
        '/projectOffice/record',
        "当前位置：证书管理 > 发放记录 >记录详情",
        true
    );

    this.getList()
  },
  methods: {
    onPreview(urls) {
      this.srcList = urls
      this.showViewer = true
    },
    closeViewer() {
      this.showViewer = false
    },
    onSearch() {
      this.page = 1
      this.getList()
    },
    async getList() {
      let _list = await certRecord(this.$route.query.id, this.stu_name, this.stu_idcard, this.stu_phone, this.page, this.limit)
      _list.data.data.map(item=>{
        item.urls = []
        item.exam_ticket_path.map(items=>{
          item.urls.push(this.imgStr +'/' +items)
        })


      })
      this.recordList = _list.data.data
      this.total = _list.data.total
    }
  },
  watch: {
    page() {
      this.getList()
    },
    $route() {
      this.getList();
    }
  }
}
</script>

<style scoped lang="scss">

</style>